module.exports = "<div>\r\n<gw-displaykey-format format=\"{{'gateway.controllers.renewal.RenewalDetailCtrl.Was this renewal started by mistake?' | translate }}\">\r\n    <a gw-displaykey-format-replaces=\"link\" ng-click=\"$close()\">{{'gateway.controllers.renewal.RenewalDetailCtrl.Withdraw renewal transaction.' | translate }}</a>\r\n</gw-displaykey-format>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/renewal/renewal-modal-withdraw.html
// module id = 827
// module chunks = 0